import React, { useState, useRef } from 'react';
import { navData } from '../../../data/nav-data';
import { authData } from '../../../data/header-data';
import { useDispatch, useSelector } from 'react-redux';
import FlyoutLink from '../FlyoutLink/FlyoutLink';
import FlyoutContent from '../FlyoutLink/FlyoutContent';
import { Link } from 'react-router-dom';
import ChangeLanguage from '../ChangeLanguage';
import { CgProfile } from 'react-icons/cg';
import { FiChevronDown } from 'react-icons/fi';
import { GoBellFill } from 'react-icons/go';
import CustomModal from '../CustomModal';
import BulletinBoard from '../BuletinBoard';
import {
  closeBulletin,
  openBulletin,
  selectBulletinOpen,
  toggleBulletin,
} from '../../../slices/bulletinSlice';
import NavDropdown from './NavDropdown';
import NavOptions from '../NavOptions';

const Navbar = () => {
  const { language } = useSelector((state) => state.language);
  const locale = language?.locale;
  const [activeDropdown, setActiveDropdown] = useState(null);
  const setHoverTimeout = useRef(null);

  const dispatch = useDispatch();
  const isBulletinOpen = useSelector(selectBulletinOpen);

  return (
    <div className="relative flex w-full items-center justify-around bg-orange-500 py-2 font-thin text-richblack-5 shadow-md">
      <div className="flex items-center gap-4">
        <ChangeLanguage />
      </div>

      <div className="flex">
        {navData.map((nav, index) => (
          <div
            key={index}
            className="group relative mx-4 flex cursor-pointer items-center justify-center"
          >
            <span className="relative text-lg font-medium text-richblack-5 transition duration-300 hover:text-blue-500">
              {nav?.dropdown ? (
                // <FlyoutLink
                //   FlyoutContent={() => (
                //     // <FlyoutContent links={nav.dropdownData} language={locale} />
                //     <NavOptions links={nav.dropdownData} language={locale} />
                //   )}
                //   styles={'richblack-5'}
                // >
                //   {nav?.title[locale]}
                // </FlyoutLink>
                <NavOptions
                  links={nav.dropdownData}
                  language={locale}
                  dropdownContainerClass={nav?.dropdownContainerClass}
                  arrowClass={nav?.arrowClass}
                  id={index}
                  activeDropdown={activeDropdown}
                  setActiveDropdown={setActiveDropdown}
                  setHoverTimeout={setHoverTimeout}
                >
                  {nav?.title[locale]}
                </NavOptions>
              ) : (
                <div className="group">
                  <Link to={nav?.path}>{nav?.title[locale]}</Link>
                </div>
              )}

              <div className="duration-1300 absolute -bottom-2 hidden h-1 w-full rounded-lg bg-blue-500 transition ease-in group-hover:block"></div>
            </span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-6 text-2xl">
        <div
          className="relative cursor-pointer"
          onClick={() => dispatch(openBulletin())}
        >
          <span className="absolute right-0 h-2 w-2 animate-ping rounded-full bg-customRed-500 opacity-75"></span>
          <span className="absolute right-0 h-2 w-2 rounded-full bg-customRed-500"></span>
          <GoBellFill />
        </div>
        <div>
          {authData.map((authData, index) => (
            <Link
              key={index}
              to={authData?.path}
              className="flex items-center capitalize hover:text-blue-400 hover:underline"
            >
              <CgProfile className="mr-2 text-2xl font-semibold" />
              <FiChevronDown className="text-2xl font-semibold" />
            </Link>
          ))}
        </div>
      </div>

      {/* Overlay and Testimonial Modal */}
      {isBulletinOpen && (
        <div className="absolute">
          <CustomModal
            open={isBulletinOpen}
            setOpen={() => dispatch(closeBulletin())}
            componentToRender={<BulletinBoard />}
          />
        </div>
      )}
    </div>
  );
};

export default Navbar;
